export default {
favorites_link: "المفضلة",
your_recomendations: "توصياتك",
loading_perfumes: "تحميل العطر",
filter_by_gender: "الجنس",
for_him: "له",
for_her: "لها",
filter_by_family: "عائلة",
filter_by_brand: "العلامة التجارية",
all: "الكل",
all_femenine: "الكل",
you_may_also_like: "قد ترغب أيضا",
ingredients: "المكونات",
perfumist: "عطر",
description: "وصف",
olfactive_family: "عائلة عطرية",
expert_reviewed: "رأي الخبراء",
main_family: "عائلة",
sub_family: "فصيلة",
me_family: "عطور العالم"
}